import { __extends } from "tslib";
// DS: UI08
/*  (BackToTop variant used in ScrollableContent) */
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import ArrowUp from '@wix/da-ds/pkg/Icons/ArrowUp';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { scrollTo } from '../utils/browser';
import backToTopStyle from './BackToTop.scss';
/** A 'hop to top' button that sends the user back to the top of some scrollable area
 *  This is a simplified version of the original BackToTop that doesn't need to account
 *  for PerspectiveContainers, or BI (yet) but still share the design
 *  elements of the original. */
var SimpleBackToTop = /** @class */ (function (_super) {
    __extends(SimpleBackToTop, _super);
    function SimpleBackToTop() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // TODO: use this within BackToTop so that it's truly shared
        _this.onClick = function () {
            var _a = _this.props, scrollToY = _a.scrollToY, getScrollableContainer = _a.getScrollableContainer;
            var scrollableContainer = getScrollableContainer();
            if (scrollableContainer) {
                scrollTo(scrollableContainer, {
                    left: 0,
                    top: scrollToY || 0,
                    behavior: 'smooth',
                });
            }
        };
        return _this;
    }
    SimpleBackToTop.prototype.renderButton = function () {
        var _a = this.props, _b = _a.scrolled, scrolled = _b === void 0 ? false : _b, className = _a.className, stuckClassName = _a.stuckClassName;
        return (React.createElement(PlainButtonOrLink, { onClick: this.onClick, className: classnames(backToTopStyle['root'], className, scrolled && backToTopStyle['stuck'], scrolled && stuckClassName) },
            React.createElement(ArrowUp, { disableDefaultColors: true, size: IconSize.SMALL })));
    };
    SimpleBackToTop.prototype.render = function () {
        var forcedTheme = this.props.forcedTheme;
        return forcedTheme ? (React.createElement(ThemeOverride, { theme: forcedTheme }, this.renderButton())) : (this.renderButton());
    };
    return SimpleBackToTop;
}(React.Component));
export default SimpleBackToTop;
//# sourceMappingURL=SimpleBackToTop.js.map